// @flow
import { getCreator, postCreator } from '../../../http';
import environment from '../../../environment';

export const endpoints = Object.freeze({
  GET_WISH_LISTS: `${environment.apiUrl}/wishlist/:userId/list`,
  POST_PRODUCT_WISH_LIST: `${environment.apiUrl}/wishlist/:nameSlug`,
  POST_NEW_WISH_LIST: `${environment.apiUrl}/wishlist/`,
  SEND_QUOTE_MAIL: `${environment.apiUrl}/purchase/send-pricing-email`,
});

export const getWishListsApi = getCreator(fetch, endpoints.GET_WISH_LISTS);
export const postProductToWishListApi = postCreator(fetch, endpoints.POST_PRODUCT_WISH_LIST);
export const postNewWishListApi = postCreator(fetch, endpoints.POST_NEW_WISH_LIST);
export const sendQuoteMailApi = postCreator(fetch, endpoints.SEND_QUOTE_MAIL);



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/api.js